import { useInfiniteQuery } from '@tanstack/react-query';
import { getNotification } from '../api/api';
import { API_URLS_ENTITY } from '../constants/apiUrl';

export interface IUserNotificationFilters {
  cursor?: string;
  to?: string;
  from?: string;
  unreadOnly?: string;
  search?: string;
}

export const useFetchNotifications = (params?: IUserNotificationFilters) => {
  const fetchNotifications = async ({ pageParam = '' }) => {
    const queryParams: Record<string, string> = {
      ...params,
      cursor: pageParam,
    };

    const cleanParams = Object.fromEntries(
      Object.entries(queryParams).filter(([_, v]) => v != null && v !== ''),
    );

    const queryString = new URLSearchParams(cleanParams).toString();
    const url = `${API_URLS_ENTITY.NOTIFICATIONS.NOTIFICATION_FEED}?${queryString}`;

    try {
      return await getNotification(url); // Should return an array
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw new Error((error as { message: string }).message || 'Failed to fetch notifications');
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    queryKey: ['notification-list', params],
    queryFn: fetchNotifications,
    initialPageParam: '',
    getNextPageParam: (lastPage) => {
      const lastItem = lastPage?.[lastPage.length - 1];
      return lastItem?.id || undefined;
    },
    refetchOnMount: true,
  });

  return {
    data: data?.pages.flat() ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
